import {Input} from "./Input.js";


export class NameInput extends Input {

    template() {
        const {addClassName = "" , value = ""} = this.$props;
        const isVal = Mutil.exist(value);

        return `
            <div class="interactive-form-wrap js-interactive-form-wrap ${isVal ? 'interactive' : ""}">
                <input type="text"
                    autocomplete="off"
                    id="joinUserName"
                    class="js-name-input join-name-input interactive-form-input ${addClassName}"
                    placeholder=""
                    data-required-yn="Y"
                    maxlength="${Often.isGlobal() ? 80 : 20}"
                    data-valid="name"
                    data-empty-msg="${i18next.t(login.common.enter, {val: $t(dictionary.name)})}"
                    data-un-valid-msg="${i18next.t(login.recheckName)}"
                    tabindex="1"
                    data-over-msg="${i18next.t(login.inputAlert, {val: Often.isGlobal() ? 80 : 20})}"
                />
                <span class="interactive-form-placeholder">${i18next.t(login.enterName)}</span>
            </div>
            <p class="error-txt-wrap">
                <span class="js-error-txt"></span>
            </p>
        `
    }

    mounted() {
        const { value = ""} = this.$props;
        this.get$Input().focus();

        if(Mutil.empty(value)) {
            return;
        }
        this.get$Input().val(value)
    }
    getInputSelector() {
        return "#joinUserName";
    }
}
